import React, { useState } from 'react';
import iconCloseArrow from "url:shared-assets/icons/hide-panel.svg";

interface Props {
  children: React.ReactNode;
  close: () => void;
}

const SidePanel = (props: Props) => {
  const [isOpen, setIsOpen] = useState("open");


  const close = () => {
    setIsOpen("closed");
    setTimeout(() => {
      props.close()
    }, 400);
  }

  return (
    // <div className="z-side-panel-background" onClick={() => close()}>
      <div className={"z-side-panel " + isOpen}>
        <div className="cursor-pointer hover:bg-indigo-700 rounded-[20px] p-1"
             style={{position: "absolute", top: "16px", right: "16px"}} onClick={() => close()}>
          <img src={iconCloseArrow} alt="close"/>
        </div>
        {props.children}
      </div>
    // </div>
  )
}

export default SidePanel;